<template>
  <nav id="section-nav" :style="`--tabs-indicator-width: ${indicator.w}; --tabs-indicator-offset: ${indicator.o}`">
    <div class="tab-list-scroll-container">
      <ul class="tab-list">
        <li v-for="(label, index) in tabs" :data-tab-index="index + 1" :class="activeTabIndex === index + 1 ? 'active' : ''">
          <router-link :to="`/${$i18n.locale}/form/${index + 1}?id=${id}`">{{ label.get() }}</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script lang="ts" setup>
import { defineProps, onMounted, reactive, ref } from 'vue';
import LocalizedString from '../models/LocalizedString';
import Manager from '../../../core/Manager';

const props = defineProps({
  form: Object
});

const activeTabIndex = ref(0);

const indicator = reactive({
  w: 0,
  o: 0
});

const updateTabs = (activeIndex) => {
  const tab = document.querySelector(`[data-tab-index="${activeIndex}"]`) as HTMLElement;
  const w = tab.offsetWidth;
  const o = tab.offsetLeft;
  indicator.w = w;
  indicator.o = o;
  activeTabIndex.value = parseInt(activeIndex);
  document.querySelector('#section-nav .tab-list-scroll-container').scroll({
    left: o,
    behavior: 'smooth'
  });
};

const tabs = ref();
const id =  ref();
onMounted(() => {
  id.value = Manager.getInstance().submission.id;
  tabs.value = props.form.json.map((a) => new LocalizedString(a.name));
});

defineExpose({
  updateTabs
})

</script>
